import React, {useContext} from 'react'
import AppContext from "../../../common/context/app-context";

const ShowAddProductToShopify = ({productDetail}) => {
    const appContext = useContext(AppContext);
    let {shopifyDetail, addShopifyProduct} = appContext;

    return (
        <>
            <div className="flex justify-between">
                {shopifyDetail?.productIds?.indexOf(productDetail?.id) === -1 ?
                    <button
                        onClick={() => {
                            addShopifyProduct(productDetail)
                        }}
                        className="button-gray-outline py-2 px-3 mx-1 flex justify-center">
                        <span className="">Add Product</span>
                    </button>
                    : <button
                        className="button-purple py-2 px-3 mx-1 flex justify-center">
                        <span className="">Product Added ({shopifyDetail?.productIds?.length})</span>
                    </button>
                }
            </div>

        </>
    )
}

export default ShowAddProductToShopify
